import { Grid, Stack, Typography } from "@mui/material";
import useGetCurrentTenant from "../../hooks/tenants/get-current-tenant.hook";
import Contracts from "./contracts";
import TenantsEmptyState from "./empty-state";
import LoadingSkeleton from "@/modules/common/components/ui/loadingSkeleton";
import TenantDetails from "./tenant-details";

export default function TenantsTab({
  propertyUid,
}: Readonly<{ propertyUid: string }>) {
  const {
    data: currentTenantContract,
    isLoading,
    isError,
  } = useGetCurrentTenant({ propertyUid });

  if (isLoading) {
    return <LoadingSkeleton columns={2} />;
  }

  if (isError || !currentTenantContract) {
    return <TenantsEmptyState />;
  }

  return (
    <Stack
      alignItems="center"
      gap={(theme) => theme.nawy.spacing.md}
      width="100%"
      height="100%"
    >
      <Grid
        container
        gap={(theme) => theme.nawy.spacing.md}
        width="100%"
        overflow="hidden"
      >
        <Grid
          size={{ mobile: 12, desktop: 6.5 }}
          width="100%"
          borderRadius={(theme) => theme.nawy.radius.xl}
          bgcolor="white"
          p={(theme) => theme.nawy.spacing.md}
          height="fit-content"
        >
          <TenantDetails
            currentTenantContract={currentTenantContract}
            propertyUid={propertyUid}
          />
        </Grid>
        <Grid
          size={{ mobile: 12, desktop: 5 }}
          maxWidth="100%"
          borderRadius={(theme) => theme.nawy.radius.xl}
          bgcolor="white"
          height="fit-content"
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            p={(theme) => theme.nawy.spacing.md}
          >
            <Typography fontSize={14} fontWeight={600}>
              Contract
            </Typography>
          </Stack>
          <Contracts currentTenant={currentTenantContract} />
        </Grid>
      </Grid>
    </Stack>
  );
}
